"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ArrowsDiagonalOut16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.24264 2.60831L9.20028 0.668278L14.697 0.828423L14.8571 6.32513L12.9171 6.28278L12.8455 4.09407L9.37603 7.56351L7.96186 6.14934L11.4314 2.67988L9.24264 2.60831ZM6.28277 12.9171L6.32513 14.8571L0.828419 14.697L0.668274 9.20028L2.60831 9.24264L2.67988 11.4313L5.80563 8.30566L7.2198 9.71983L4.09403 12.8455L6.28277 12.9171Z", fill: "black" }));
}
function ArrowsDiagonalOut16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ArrowsDiagonalOut16Svg, Object.assign({}, svgProps)));
}
exports.default = ArrowsDiagonalOut16;
//# sourceMappingURL=ArrowsDiagonalOut16.js.map